import type { GTMEventReturnType } from './GTM.types';

declare global {
    interface Window {
        dataLayer: (
            | GTMEventReturnType
            | { event: 'cookie_consent_update' }
            | { ecommerce: null }
        )[];
    }
}

export default class GTM {
    static clearEcommerce(): void {
        if (typeof window === 'undefined' || !window.dataLayer) {
            return;
        }

        window.dataLayer.push({ ecommerce: null });
    }

    static cookieConsentUpdate(): void {
        if (typeof window === 'undefined' || !window.dataLayer) {
            return;
        }

        window.dataLayer.push({ event: 'cookie_consent_update' });
    }

    static track<DT extends GTMEventReturnType>(eventData: DT): void {
        if (typeof window === 'undefined' || !window.dataLayer) {
            return;
        }

        window.dataLayer.push(eventData);
    }
}
